import { useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { SendPostRequest } from "../../http";
import { Link } from "react-router-dom";
import createSlug from "../../utils/CreateSlug";
import Spinner from "../Spinner";

function DropDownCtaDoctors() {
  const [doctorsData, setDoctorsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getDoctorsData();
  }, []);

  const getDoctorsData = async () => {
    try {
      const response = await SendPostRequest("doctors/list");
      setDoctorsData(response?.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching doctors data:", error);
    }
  };

  const owlOptions = {
    loop: doctorsData.length > 4,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 2500,
    autoplayHoverPause: true,
    smartSpeed: 1000,
    margin: 30,
    responsive: {
      0: { items: 1 },
      600: { items: 2 },
      1000: { items: 4},
    },
  };

  return (
    <section className="page-section bg-grey border-tb py-5">
      <div className="container">
        <div className="offset-md-2 col-md-8">
          <div className="title-wrap text-center">
            <div className="section-title margin-bottom-60">
              <h2 className="section-title mb-0 text-uppercase">
                MEET OUR <span className="theme-color">SPECIALISTS</span>
              </h2>
              <span className="section-border-bottom center"></span>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="col-12 text-center">
            <Spinner />
          </div>
        ) : doctorsData?.length > 0 ? (
          <OwlCarousel className="owl-theme shop style-2 popup-gallery" {...owlOptions}>
            {doctorsData?.map((data, index) => (
              <div className="" key={index}>
                <div className="product-item mb-5">
                  <div className="product-box-wrap">
                    <div className="product-img">
                      <div
                        style={{
                          backgroundImage: `url(${data?.profile})`,
                          backgroundPosition: "top center",
                          backgroundSize: "cover",
                          backgroundRepeat: "no-repeat",
                          height: "280px",
                        }}
                      ></div>
                      <Link
                        to={`/doctor/${data?.uid}/${createSlug(data?.full_name)}`}
                        className="popup-img"
                        title="Open Profile"
                      >
                        <i className="ti-plus text-white"></i>
                      </Link>
                    </div>
                    <div className="product-details text-center mt-3">
                      <h5 className="mb-0">
                        <Link
                          to={`/doctor/${data?.uid}/${createSlug(data?.full_name)}`}
                          className="text-dark"
                        >
                          {data?.full_name}
                        </Link>
                      </h5>
                      <h5 className="theme-color">{data?.department}</h5>
                    </div>
                  </div>
                  <Link
                    to={`/doctor/${data?.uid}/${createSlug(data?.full_name)}`}
                    className="btn btn-default btn-block"
                  >
                    Book An Appointment
                  </Link>
                </div>
              </div>
            ))}
          </OwlCarousel>
        ) : (
          <div className="col-12 text-center">
            <h4>No Doctors Found</h4>
          </div>
        )}
      </div>
    </section>
  );
}

export default DropDownCtaDoctors;